import React from 'react';
import ChatbotWidget from '../ChatbotWidget';

const HomePage = () => {
  return (
    <div>
      {/* <h1>Webethics Chatbot</h1> */}
      <ChatbotWidget />
    </div>
  );
};

export default HomePage;
